module.exports = (window.RhythmVendor) ? RhythmVendor.factory.get('handlebars') : Handlebars;